import { Component, HostListener, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DateFormatService } from 'src/app/Services/Utilities/date-format.service';
import { UserInfoService } from 'src/app/Services/Utilities/user-info.service';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-profile-pop',
  templateUrl: './profile-pop.component.html',
  styleUrls: ['./profile-pop.component.css']
})
export class ProfilePopComponent implements OnInit {


  hidePassword = true;
  hidePasswordR = true;
  hideConfirmPasswordR = true;

  private dateFormat = new DateFormatService();

  registerModel = {
    name: '',
    nameE: false,
    telephoneNo: '',
    telephoneNoE: false,
    email: '',
    emailE: false,
    ic: '',
    icE: false,
    pos: '',
    posE: false,
    schoolName: '',
    schoolNameE: false,
    add1: '',
    add1E: false,
    add2: '',
    add3: '',
    postcode: '',
    postcodeE: false,
    city: '',
    cityE: false,
    state: '',
    stateE: false,
    country: '',
    countryE: false,
    nationality: '',
    nationalityE: false,
    faxNo: '',
    password: '',
    passwordE: false,
    confirm_password: '',
    confirm_passwordE: false,

  };

  flag = true;
  validationsMessages = ' ';
  today = Date.now();
  app;

  uid;
  role: string[];

  constructor(
    private router: Router,
    private toast: ToastrService,
    private angularFireAuth: AngularFireAuth,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private userinfoSrv: UserInfoService,
    private firestore: AngularFirestore,
    public dialogRef: MatDialogRef<ProfilePopComponent>,

  ) {
    this.spinner.show()

    this.userinfoSrv.currentRole.subscribe(role=>this.role = role);
    this.angularFireAuth.authState.subscribe(async authState => {
      this.uid = authState.uid;
      this.registerModel.email = authState.email;
      this.spinner.hide();
    })

  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnInit() {

  }

  validateEmail(value) {
    if ((/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value))) {
      return false;
    }
    return true;
  }
  validatePhone(value) {
    if (value.length > 8 && value.length < 20) {
      return false;
    }
    return true;
  }

  validate(value) {
    if (!value) {
      return true;
    }
    return false;
  }

  SelectPos(pos) {
    this.registerModel.pos = pos;
  }

  async update() {
    let flag = false;

    this.registerModel.nameE = this.validate(this.registerModel.name);
    this.registerModel.telephoneNoE = this.validate(this.registerModel.telephoneNo);
    this.registerModel.emailE = this.validate(this.registerModel.email);

    this.registerModel.icE = this.validate(this.registerModel.ic);
    this.registerModel.posE = this.validate(this.registerModel.pos);
    this.registerModel.schoolNameE = this.validate(this.registerModel.schoolName);
    this.registerModel.add1E = this.validate(this.registerModel.add1);
    this.registerModel.postcodeE = this.validate(this.registerModel.postcode);
    this.registerModel.cityE = this.validate(this.registerModel.city);
    this.registerModel.stateE = this.validate(this.registerModel.state);
    this.registerModel.countryE = this.validate(this.registerModel.country);
    this.registerModel.nationalityE = this.validate(this.registerModel.nationality);
    this.registerModel.emailE = this.validateEmail(this.registerModel.email);

    if (this.registerModel.nameE || this.registerModel.telephoneNoE ||
      this.registerModel.emailE || this.registerModel.icE ||
      this.registerModel.posE || this.registerModel.schoolNameE ||
      this.registerModel.add1E || this.registerModel.postcodeE ||
      this.registerModel.cityE || this.registerModel.stateE ||
      this.registerModel.countryE || this.registerModel.nationalityE || this.registerModel.emailE
    ) {
      flag = true;
    }



    if (flag) {
      this.toast.error("Please make sure the form is filled in correct value")
      return;
    }

    const email = this.registerModel.email;
    const password = this.registerModel.password;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.height = 'auto';
    dialogConfig.width = 'auto';

    const position = { top: '10%' };
    dialogConfig.position = position;
    dialogConfig.disableClose = true;
    dialogConfig.data = 'Confirm create profile information?';
    this.spinner.hide();

    this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(async data => {
      if (data) {
        this.spinner.show();

        let newUserInfo = {
          UpdatedDate: new Date(),
          UpdatedBy: email,
          Email: email,
          Role: "User",
          Name: this.registerModel.name,
          TelephoneNo: this.registerModel.telephoneNo,
          IC: this.registerModel.ic,
          Position: this.registerModel.pos,
          SchoolName: this.registerModel.schoolName,
          Address1: this.registerModel.add1,
          Address2: this.registerModel.add2,
          Address3: this.registerModel.add3,
          State: this.registerModel.state,
          Postcode: this.registerModel.postcode,
          Country: this.registerModel.country,
          City: this.registerModel.city,
          Nationality: this.registerModel.nationality,
          FaxNo: this.registerModel.faxNo
        }
        const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
        const info = {
          message: "Profile has been inserted. Email: " + email,
          date: new Date(),
          data: newUserInfo
        };
        this.spinner.hide();
        await this.firestore.collection("Users").doc(this.uid).set(newUserInfo);
        await this.firestore.collection('UsersLog').doc(dateFormat).set({ Date: new Date() });
        await this.firestore.collection('UsersLog').doc(dateFormat).collection('User').add(info);
        this.toast.success("Create successful")
        this.dialogRef.close(true)
      }
    });
  }

  goProfile(){
    this.router.navigate(['profile'])
  }
  goExhibition(){
    this.router.navigate(['innovation'])
  }

}
